<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="27" viewBox="0 0 36 27" fill="none">
    <path
      d="M1.62646 23.3238V3.67579C1.62646 3.09679 1.85647 2.54151 2.26588 2.1321C2.6753 1.72268 3.23058 1.49268 3.80958 1.49268H32.1901C32.7691 1.49268 33.3244 1.72268 33.7338 2.1321C34.1432 2.54151 34.3732 3.09679 34.3732 3.67579V23.3238C34.3732 23.9028 34.1432 24.4581 33.7338 24.8675C33.3244 25.2769 32.7691 25.507 32.1901 25.507H3.80958C3.23058 25.507 2.6753 25.2769 2.26588 24.8675C1.85647 24.4581 1.62646 23.9028 1.62646 23.3238Z"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.08496 20.0493H20.1837"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.5493 20.0493H28.9155"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5428 6.95068H7.08496V11.3169H12.5428V6.95068Z"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.3672 9.40625C22.8192 9.40638 23.1855 9.77353 23.1855 10.2256C23.1854 10.6775 22.8191 11.0438 22.3672 11.0439C21.9151 11.0439 21.548 10.6776 21.5479 10.2256C21.5479 9.77345 21.915 9.40625 22.3672 9.40625Z"
      fill="#551AFF"
      fill-opacity="0.95"
      stroke="currentColor"
      stroke-width="0.545779"
    />
    <path
      d="M25.106 11.8344C25.4537 11.3696 25.6416 10.8048 25.6416 10.2243C25.6416 9.64385 25.4537 9.07901 25.106 8.61426"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.7485 13.7729C28.5073 12.7457 28.9167 11.5023 28.9167 10.2253C28.9167 8.94828 28.5073 7.70491 27.7485 6.67773"
      stroke="currentColor"
      stroke-width="2.18312"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
